/* global axios */
import ApiClient from './ApiClient';

// NB: do NOT name the per-bot URL helper `baseUrl` — ApiClient's `get url()`
// getter calls `this.baseUrl()`, so overriding it here recurses infinitely.
class KnowledgeEnrichmentSuggestionsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  scopedUrl(agentBotId) {
    return `${this.url}/${agentBotId}/knowledge_enrichment/suggestions`;
  }

  index(agentBotId, { page = 1, status = 'open', language, search } = {}) {
    return axios.get(this.scopedUrl(agentBotId), {
      params: { page, status, language, search },
    });
  }

  show(agentBotId, id) {
    return axios.get(`${this.scopedUrl(agentBotId)}/${id}`);
  }

  update(agentBotId, id, data) {
    return axios.patch(`${this.scopedUrl(agentBotId)}/${id}`, {
      suggestion: data,
    });
  }

  approve(agentBotId, id, data = {}) {
    return axios.post(`${this.scopedUrl(agentBotId)}/${id}/approve`, {
      suggestion: data,
    });
  }

  dismiss(agentBotId, id) {
    return axios.post(`${this.scopedUrl(agentBotId)}/${id}/dismiss`);
  }
}

export default new KnowledgeEnrichmentSuggestionsAPI();
